<app-masterheader></app-masterheader>

<div class="wrapper">
    <app-sidebar></app-sidebar>
    <div id="content">
        <div class="container-fluid">
                  <!-- Horizontal Tab Navigation -->
      <ul class="nav nav-tabs mb-4 mt-3 justify-content-start">
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ active: selectedTab === 'timeline' }" href="#" (click)="selectTab('timeline')">
            🕒 Timeline
          </a>
        </li>
        <!-- Future Tabs -->
        <!-- <li class="nav-item">
          <a class="nav-link" [ngClass]="{ active: selectedTab === 'progress' }" href="#" (click)="selectTab('progress')">
            📈 Work Progress
          </a>
        </li> -->
      </ul>
 
      <!-- Timeline Tab Content -->
      <div *ngIf="selectedTab === 'timeline'">
        <div class="card shadow-sm">
          <div class="card-header bg-success text-white d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Set Timeline for APO Components</h5>
            <button class="btn btn-sm btn-light text-success border border-success"  (click)="openConfirmModal('all')">
              ✅ Save All Timelines
            </button>
          </div>

          <div class="card-body">
            <!-- Row-wise Dropdown Selection -->
            <div class="row mb-4">
                          <div class="col-3 mb-3">
                            <label class="form-label fw-bold">Financial Year</label>
                             <input type="text" [value]="yearRange"  readonly class="form-control form-control-sm">
                          </div>
                          <div class="col-3 mb-3">
                            <label class="form-label fw-bold">Major Scheme</label>
                            <select class="form-select w-100" [(ngModel)]="selectedMajorScheme" (change)="onMajorSchemeChange()">
                              <option value="">All</option>
                              <option *ngFor="let scheme of schemeList" [value]="scheme.id">{{ scheme.name }}</option>
                            </select>
                          </div>
                          <div class="col-3 mb-3">
                            <label class="form-label fw-bold">Scheme Details</label>
                            <select class="form-select w-100" [(ngModel)]="selectedScheme" (change)="onSchemeChange()">
                              <option value="">All</option>
                              <option *ngFor="let scheme of subSchemeList" [value]="scheme.id">{{ scheme.name }}</option>
                            </select>
                          </div>
                          <div class="col-3 mb-3">
                            <label class="form-label fw-bold">Component</label>
                            <select class="form-select w-100" [(ngModel)]="selectedComponent" (change)="loadTimelines()">
                              <option value="">All</option>
                  <option *ngFor="let component of componentList" [value]="component.id">{{ component.name }}</option>
                </select>
              </div>
            </div>
        
             <!-- Search Field Above Table -->
            <div class="row mb-3 align-items-end">
              <div class="col-md-6">
                <label class="form-label fw-bold">Search Division</label>
                <input type="text" class="form-control" [(ngModel)]="divisionSearch" placeholder="Type division name to filter...">
              </div>
              <div class="col-md-2">
                <button class="btn btn-outline-secondary mt-2" (click)="clearSearch()">Clear Search</button>
              </div>
                <div class="col-md-4  text-end mt-2">
                    <button class="btn btn-outline-primary float-right" *ngIf="selectedComponent" (click)="openTimelineModal()">
                        ➕ Create Timeline
                    </button>
               </div>
            </div>
                      

            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead class="table-light text-center">
                  <tr>
                    <th>#</th>
                    <th>Division</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of  filteredTimelines(); let i = index" [class.table-warning]="row.isEditMode"  >
                    <td class="text-center">{{ i + 1 }}</td>
                    <td>{{ row.divisionName }}</td>
                    <td><input type="date" class="form-control" 
                      [(ngModel)]="row.startDate" 
                      [disabled]="!row.isEditMode"
                      [ngClass]="{
                        'border-success text-success fw-bold': row.timelineStatus === 'Active',
                        'border-danger text-danger fw-bold': row.timelineStatus === 'Exceeded',
                        'border-primary text-primary fw-bold': row.timelineStatus === 'Not Started'
                      }"></td>
                    <td><input type="date" class="form-control" 
                      [(ngModel)]="row.endDate" 
                      [disabled]="!row.isEditMode"
                      [ngClass]="{
                        'border-success text-success fw-bold': row.timelineStatus === 'Active',
                        'border-danger text-danger fw-bold': row.timelineStatus === 'Exceeded',
                        'border-primary text-primary fw-bold': row.timelineStatus === 'Not Started'
                      }"></td>
                    <td class="text-center">
                       <!-- (click)="toggleRowEditMode(row)" -->
                       <button class="btn btn-sm btn-outline-success mr-2"    (click)="row.isEditMode ? openConfirmModal('single', row) : row.isEditMode = true">
                              {{ row.isEditMode ? '💾 Save' : '✏️ Edit Timelines' }}
                        </button>
                        <button class="btn btn-sm btn-outline-warning" (click)="clearTimeline(row)" [disabled]="!row.isEditMode">
                            🔁 Reset
                        </button>
                    </td>
                  </tr>
                  <tr *ngIf=" filteredTimelines().length === 0">
                    <td colspan="5" class="text-center text-muted">No data found. Please select a component.</td>
                  </tr>
                </tbody>
              </table>
            </div>
              <!-- Save All Button -->
            <div class="text-end mt-3">
              <button class="btn btn-outline-success" (click)="openConfirmModal('all')">✅ Save All Timelines</button>
            </div>


          </div>
        </div>
      </div>
     
      <!-- Timeline Modal -->
      
      <div class="modal fade" id="timelineModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
          <div class="modal-content shadow">
            <div class="modal-header bg-success text-white">
              <h5 class="modal-title">
                📅 Create Timeline for <span class="fw-bold text-warning">{{ selectedComponentName }}</span>
              </h5>
              <button type="button" class="btn-close text-white" data-dismiss="modal">X</button>
            </div>
      
            <div class="modal-body">
              <!-- Date Selection -->
              <div class="row mb-4">
                <div class="col-md-6 mb-3">
                  <label class="form-label fw-bold">Start Date</label>
                  <input type="date" class="form-control" [(ngModel)]="bulkStartDate">
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label fw-bold">End Date</label>
                  <input type="date" class="form-control" [(ngModel)]="bulkEndDate">
                </div>
              </div>
      
              <!-- Division Search & Select -->
              <div class="row mb-2">
                <div class="col-md-8">
                  <label class="form-label fw-bold">🔍 Search Division</label>
                  <input type="text" class="form-control" [(ngModel)]="divisionFilter"
                    placeholder="Type to filter divisions...">
                </div>
                <div class="col-md-4 d-flex align-items-end justify-content-end">
                  <div class="form-check mt-3">
                    <input type="checkbox" class="form-check-input" id="selectAll" [checked]="areAllSelected()"
                      (change)="toggleSelectAll($event)">
                    <label for="selectAll" class="form-check-label fw-bold">Select All</label>
                  </div>
                </div>
              </div>
      
              <!-- Scrollable Division List -->
              <div class="border rounded p-3 mb-4" style="max-height: 250px; overflow-y: auto; background: #f9f9f9;">
                <div *ngFor="let div of filteredTimelinesForCheck()" class="form-check mb-2">
                  <input type="checkbox" class="form-check-input" [id]="'division-' + div.divisionId"
                    [checked]="selectedDivisionIds.includes(div.divisionId)" (change)="toggleDivision(div.divisionId)">
                  <label class="form-check-label" [for]="'division-' + div.divisionId">
                    {{ div.divisionName }}
                    <span class="text-muted small ms-2" *ngIf="div.startDate || div.endDate">
                      📅 {{ div.startDate || '-' }} → {{ div.endDate || '-' }}
                    </span>
      
                  </label>
                </div>
                <div *ngIf="filteredTimelinesForCheck().length === 0" class="text-muted">
                  No divisions match your search.
                </div>
              </div>
              <!-- Selected Summary -->
              <div class="border-top pt-3">
                <label class="fw-bold">📝 Selected Divisions Summary:</label>
                <div *ngIf="selectedDivisionIds.length > 0; else noSelection">
                  <ul class="small mb-0">
                    <li *ngFor="let div of getSelectedDivisionNames().slice(0, 5)">
                      {{ div }}
                    </li>
                  </ul>
                  <div *ngIf="getSelectedDivisionNames().length > 5" class="text-muted small">
                    + {{ getSelectedDivisionNames().length - 5 }} more selected
                  </div>
                </div>
                <ng-template #noSelection>
                  <p class="text-muted small">No divisions selected yet.</p>
                </ng-template>
              </div>
            </div>
            <div class="modal-footer d-flex justify-content-between">
              <button class="btn btn-link text-danger p-0" (click)="clearAllSelections()">
                ❌ Clear All Selected
              </button>
              <div>
                <button class="btn btn-outline-success mr-2" (click)="applyBulkDates()">
                  ✅ Apply to Selected
                </button>
                <button class="btn btn-secondary" data-dismiss="modal">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>

        <!-- Confirm Save Modal -->
        <div class="modal fade" id="confirmSaveModal" tabindex="-1" aria-labelledby="confirmSaveLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header bg-warning">
                <h5 class="modal-title" id="confirmSaveLabel">Confirm Save</h5>
                <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">X</button>
              </div>
              <div class="modal-body">
                {{ confirmMessage }}
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-success" (click)="proceedSave()">Yes, Save</button>
              </div>
            </div>
          </div>
        </div>



    </div>
  </div>
  <div id="footer">
    <app-masterfooter></app-masterfooter>
  </div>
</div>
